export enum PhysicalGroup{
    main,
    preparatory
}

export const physicalGroups: any[] = [
  { id: 0, name: 'Основная' },
  { id: 1, name: 'Подготовительная' }
];